interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '云开体育',
      alternateName: 'YunKai Sports',
      url: 'https://stadbook.github.io',
      description: '云开体育是专业体育服务平台，提供体育培训、赛事组织、运动健身、场馆预约等一站式服务。',
      sameAs: [
        'https://weibo.com/yunkai-sports',
        'https://www.tiktok.com/@yunkai-sports',
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-0000',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '云开体育',
      url: 'https://stadbook.github.io',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://stadbook.github.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: data.name || '云开体育',
      description: data.description || '云开体育提供体育培训、赛事组织、运动健身、场馆预约等一站式服务。',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: data.headline || '',
      description: data.description || '',
      datePublished: data.datePublished || '',
      author: {
        '@type': 'Person',
        name: data.author || '',
      },
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: data.mainEntity || [],
      ...data,
    },
  };

  const schema = schemas[type] || {};

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}